import { render, staticRenderFns } from "./CallsWidget.vue?vue&type=template&id=48f768a9&scoped=true"
import script from "./CallsWidget.vue?vue&type=script&lang=js"
export * from "./CallsWidget.vue?vue&type=script&lang=js"
import style0 from "./CallsWidget.vue?vue&type=style&index=0&id=48f768a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f768a9",
  null
  
)

export default component.exports